import React from 'react';

const WhoThisIsFor: React.FC = () => {
  const audiences = [
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Idea-Stage Founders',
      description: 'Who need clarity before investing time and money'
    },
    {
      icon: 'ri-rocket-line',
      title: 'Early-Stage Apps',
      description: 'Needing validation before scaling'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Apps Not Gaining Traction',
      description: 'Looking to understand what\'s blocking growth'
    },
    {
      icon: 'ri-presentation-line',
      title: 'Investor-Ready Founders',
      description: 'Preparing for funding conversations'
    },
    {
      icon: 'ri-team-line',
      title: 'Teams Preparing for Scale',
      description: 'Who need objective analysis before expansion'
    },
    {
      icon: 'ri-robot-line',
      title: 'AI & No-Code Builders',
      description: 'Needing objective analysis beyond personal bias'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Who CrowdRounds Is Built For
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            If you're building an app and need clarity without guesswork, you're in the right place.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {audiences.map((audience, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-xl border border-gray-200 hover:border-teal-500 hover:shadow-lg transition-all duration-300"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-teal-500 text-white rounded-lg mb-6">
                <i className={`${audience.icon} text-2xl`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {audience.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {audience.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhoThisIsFor;
